import { LitElement, html, css } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

export class MyPageHeader extends LitElement {
  // static properties = {
  //   properyName: { state: true }
  // };

  static styles = css`
    :host {
      width: 100%;
    }

    .header__container {
      display: flex;
      justify-content: space-between;
      padding-bottom: 40px;
      font-size: 1.5rem;
    }

    @media(max-width: 768px) {
      .header__container {
        flex-direction: column;
        padding-bottom: 30px;
      }
    }
  `;

  // constructor() {
  //   super();
  // }

  render () {
    return html`
      <div class="header__container"><slot></slot></div>`;
  }
}

export class MyPageTitle extends LitElement {
  static properties = {
    title: { type: String },
    description: { type: String },
  };

  static styles = css`
    :host {
      /* width: 50%; */
      margin-block: auto;
    }
    .header__title {
      font-size: var(--article__header__font-size, 3rem);
      font-weight: var(--article__header__fw, 600);
      margin: 0;
      @media(max-width: 768px) {
        font-size: var(--article__header__font-size_mobile, 2rem);
        margin-bottom: 24px;
      }
    }
  `;

  // constructor() {
  //   super();
  //   this.title = 'XMin side';
  // }

  render () {
    return html`
      <div class='header'><h1 id='title' class='header__title'>${this.title}</h1></div>
      ${this.description !== undefined && this.description !== "" ? html`${unsafeHTML(this.description.split("\n").join("<br/>"))}` : ""}
    `;
  }
}

export class MyPageProfile extends LitElement {
  static properties = {
    name: { type: String },
    editText: { type: String },
    logoutText: { type: String },
  };

  static styles = css`
    :host {
      width: 50%;
    }
    .profile__container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 8px;
      background-color: #ffffff4d;
      padding: 24px 30px;
      margin-left: 15px;
    }
    #name {
      font-size: 1.25rem;
    }
    .profile__links {
      display: flex;
      gap: 30px;
    }
    a {
      font-size: 1rem;
      color: var(--black__text);
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
    .header__icon {
      position: relative;
      top: 6px;
      margin-right: 5px;
      font-family: 'Material Icons Outlined';
      font-weight: normal;
      font-style: normal;
      font-size: 24px;
      line-height: 1;
      letter-spacing: normal;
      text-transform: none;
      display: inline-block;
      white-space: nowrap;
      word-wrap: normal;
      direction: ltr;
      -webkit-font-smoothing: antialiased;
    }
  `;

  constructor() {
    super();
    this.name = "Kari Nordman";
    this.editText = "Rediger profil";
    this.logoutText = "Logg ut";
  }

  render () {
    return html`
      <div class='profile__container'>
        <div id='name'>${this.name}</div>
        <div class='profile__links'>
          <div>
            <a href='#' id='edit'><span class='header__icon'>edit</span>${this.editText}</a>
          </div>
          <div>
            <a href='#' id='logout'><span class='header__icon'>logout</span>${this.logoutText}</a>
          </div>
        </div>
      </div>`;
  }
}

customElements.define("mypage-header", MyPageHeader);
customElements.define("mypage-title", MyPageTitle);
customElements.define("mypage-profile", MyPageProfile);
